var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3980_271549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91875 0.380625C7.41125 -0.126875 6.58875 -0.126875 6.08125 0.380625L3.54112 2.92162L7 6.38138L10.4598 2.92162L7.91787 0.380625H7.91875ZM11.0775 3.54025L7.6195 7L11.0792 10.4598L13.6202 7.91787C14.1278 7.41037 14.1278 6.58875 13.6202 6.08213L11.0792 3.54025H11.0775ZM10.4598 11.0775L7 7.6195L3.54025 11.0792L6.08213 13.6202C6.58963 14.1278 7.41125 14.1278 7.91787 13.6202L10.4598 11.0792V11.0775ZM2.9225 10.4598L6.3805 7L2.92162 3.54025L0.380625 6.08213C-0.126875 6.58963 -0.126875 7.41125 0.380625 7.91787L2.92162 10.4598H2.9225Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3980_271549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideicon);
export default __webpack_public_path__ + "static/media/sideicon.40a21b3d.svg";
export { ForwardRef as ReactComponent };